module.exports = __webpack_public_path__ + "static/webstorm7-83e6a11b3602caf6b3e8769053f10955.png";